import { Component, Input } from '@angular/core';

@Component({
  selector: 'estimate-total',
  templateUrl: './estimate-total.component.html'
})
export class EstimateTotalComponent {
  @Input() laborTotal: number = 0;
  @Input() partTotal: number = 0;
  @Input() supplyTotal: number = 0;
  @Input() horizontal: boolean = false;

  public get total(): number {
    return this.laborTotal + this.partTotal + this.supplyTotal;
  }
} 